import { cn } from '@/lib/utils';

export function StatsHero() {
  return (
    <section className="relative overflow-hidden bg-black py-20">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="font-pixel text-4xl text-primary mb-6">
              NFT Analytics Dashboard
            </h1>
            <p className="text-muted-foreground mb-8">
              Comprehensive analytics and rarity insights for your NFT collections across all chains.
            </p>
            <ul className="space-y-4">
              {[
                'Stats for global view of rarity across all chains',
                'Trait distributions',
                'Trait combinations',
                'Token search rarity',
                'Trait searching',
              ].map((feature) => (
                <li key={feature} className="flex items-center gap-3">
                  <span className="text-primary">▶</span>
                  <span className="text-sm text-muted-foreground">{feature}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="relative aspect-[16/9] w-full">
            <div className="w-full h-full bg-[url('/images/stats-preview.png')] bg-cover bg-center rounded-lg pixel-border" />
          </div>
        </div>
      </div>
    </section>
  );
} 